import React from 'react';
import { Button } from './ui/Button';
import { Reveal } from './ui/Reveal';
import { Phone } from './ui/Phone';
import { CDN_URL } from '../constants';

export const Hero: React.FC = () => {
  // Immagini statiche personalizzate (S3/CloudFront)
  // Per un risultato perfetto usare dimensioni: 1080px x 2280px
  
  const imageLeft = `${CDN_URL}/HERO/1.avif`;
  const imageCenter = `${CDN_URL}/HERO/2.avif`;
  const imageRight = `${CDN_URL}/HERO/3.avif`;

  const handleScrollToContact = () => {
    const pageContent = document.getElementById('page-content');
    
    // 1. Trigger "Jump Out" Animation
    pageContent?.classList.add('navigating');

    // 2. Wait for animation to establish, then scroll
    setTimeout(() => {
        const element = document.getElementById('contact');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        // 3. Trigger "Jump In" Animation after scroll starts
        setTimeout(() => {
            pageContent?.classList.remove('navigating');
        }, 500);

    }, 350);
  };

  return (
    <section className="relative flex flex-col items-center justify-start md:justify-center min-h-[100svh] md:min-h-screen pt-24 md:pt-40 overflow-hidden bg-black pb-0">
      
      {/* Background Moon Decor */}
      <div className="absolute top-[10%] right-[-5%] w-[200px] md:w-[600px] h-[200px] md:h-[600px] border border-white/10 rounded-full -z-10 opacity-20 animate-[pulse_8s_ease-in-out_infinite]" />
      <div className="absolute top-[15%] right-[0%] w-[200px] md:w-[500px] h-[200px] md:h-[500px] bg-gradient-to-br from-white/[0.05] to-transparent rounded-full -z-10 blur-2xl" />
      
      <div className="max-w-6xl mx-auto px-4 md:px-6 text-center z-10 relative mb-2 md:mb-12 flex-shrink-0">
        <Reveal width="100%">
          <div className="inline-block px-3 py-1 md:px-4 md:py-1.5 mb-4 md:mb-8 border border-white/10 rounded-full bg-white/5 backdrop-blur-md">
            <span className="text-[9px] md:text-xs font-bold tracking-[0.3em] uppercase text-gray-400">Missione: Conquista dello Spazio Digitale</span>
          </div>
        </Reveal>
        
        <Reveal width="100%" delay={0.1}>
          <h1 className="text-4xl md:text-7xl lg:text-9xl font-bold tracking-tighter leading-[0.9] mb-4 md:mb-8 uppercase font-['Space_Grotesk']">
            CREATIVE <span className="text-transparent bg-clip-text bg-gradient-to-b from-white via-white to-zinc-800">SOLUTIONS.</span>
          </h1>
        </Reveal>

        <Reveal width="100%" delay={0.2}>
          <p className="text-sm md:text-2xl text-zinc-400 max-w-sm md:max-w-3xl mx-auto mb-6 md:mb-10 leading-snug md:leading-relaxed px-2 font-light italic">
            "Produciamo contenuti, generiamo risultati, facciamo crescere il tuo business."
          </p>
        </Reveal>

        {/* CTA Button - Hidden on Mobile, Visible on Desktop */}
        <Reveal width="100%" delay={0.4} className="hidden md:block">
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button 
                onClick={handleScrollToContact} 
                withArrow 
                className="bg-white text-black hover:bg-zinc-200 hover:scale-105 shadow-[0_0_50px_rgba(255,255,255,0.1)] px-8 py-3 md:px-12 md:py-5 text-sm md:text-lg"
              >
                  Lancia il tuo Brand
              </Button>
            </div>
        </Reveal>
      </div>

      <div className="relative w-full max-w-[1200px] mx-auto h-[40vh] min-h-[350px] md:h-[700px] perspective-[2000px] mt-4 md:mt-0 z-10 flex-grow md:flex-grow-0">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[600px] h-[300px] bg-white/[0.03] blur-[100px] rounded-full" />

        {/* Left Phone */}
        <div className="absolute left-1/2 top-10 md:top-12 md:left-[28%] transform -translate-x-[160%] md:-translate-x-[50%] rotate-[-25deg] md:rotate-[-10deg] z-10 w-[140px] md:w-[240px] opacity-90 transition-all duration-1000 hover:z-30 hover:scale-105 hover:opacity-100 hover:rotate-[-5deg] group">
             <Phone 
                image={imageLeft}
                objectFit="cover"
                loading="eager" // Hero images should load immediately
             />
        </div>

        {/* Right Phone */}
        <div className="absolute left-1/2 top-10 md:top-12 md:left-auto md:right-[28%] transform translate-x-[60%] md:translate-x-[50%] rotate-[25deg] md:rotate-[10deg] z-10 w-[140px] md:w-[240px] opacity-90 transition-all duration-1000 hover:z-30 hover:scale-105 hover:opacity-100 hover:rotate-[5deg] group">
             <Phone 
                image={imageRight}
                objectFit="cover"
                loading="eager"
             />
        </div>

        {/* Center Phone */}
        <div className="absolute left-1/2 top-0 transform -translate-x-1/2 z-20 w-[160px] md:w-[290px] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.5)] hover:-translate-y-6 transition-all duration-700 ease-[cubic-bezier(0.34,1.56,0.64,1)]">
             <Phone 
                image={imageCenter}
                objectFit="cover"
                loading="eager"
             />
        </div>
      </div>
    </section>
  );
};